export default __webpack_public_path__ + "static/media/bg-img6.272f7181.jpg";